import { render, staticRenderFns } from "./SmsTemplateEditor.vue?vue&type=template&id=47e797e8&scoped=true"
import script from "./SmsTemplateEditor.vue?vue&type=script&lang=js"
export * from "./SmsTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplateEditor.vue?vue&type=style&index=0&id=47e797e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e797e8",
  null
  
)

export default component.exports